"use strict";

exports.__esModule = true;
exports.UtilizationSummaryChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RestAPI = require("../../../API/RestAPI");
var _Spinner = require("../../../Core/Spinner");
var _SelectedDevicesController = require("../../../Device/SelectedDevicesController");
var _TimeContext = require("../../../Time/TimeContext");
var _TimePeriodController = require("../../../Time/TimePeriodController");
var _AggregateMetricChartController = require("../../common/AggregateMetricCharts/AggregateMetricChartController");
var _ScrollableChart = require("../../common/AggregateMetricCharts/ScrollableChart");
var _getMetricQuery = require("../../common/getMetricQuery");
var _stateDetails = require("../stateDetails");
var _UtilizationSummaryDataFormatter = require("./UtilizationSummaryDataFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationSummaryChart__ErrorText",
  componentId: "sc-1w3fp0w-0"
})(["display:flex;justify-content:center;align-items:center;font-size:17px;font-weight:500;"]);
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationSummaryChart__Wrapper",
  componentId: "sc-1w3fp0w-1"
})(["display:flex;", ""], _stateDetails.stateDetails.map(function (item) {
  return "[data-key=\"" + item.key + "\"]{\n        fill: " + item.color + ";\n        background: " + item.color + ";\n      }";
}).join(" "));
var UtilizationSummaryChart = exports.UtilizationSummaryChart = function UtilizationSummaryChart(props) {
  var _React$useContext = _react["default"].useContext(_RestAPI.RestAPIContext),
    plantName = _React$useContext.plantName;
  var _React$useContext2 = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext2.timezone;
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  var timePeriod = (0, _TimePeriodController.useSelectionContext)();
  var selectedStates = props.selectedStates,
    height = props.height,
    width = props.width,
    tooltipSort = props.tooltipSort;
  var tickXFormatter = function tickXFormatter() {
    return "";
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    "data-testid": "UtilizationSummaryChart",
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(_AggregateMetricChartController.AggregateMetricChartController, {
    query: (0, _getMetricQuery.getMetricQuery)({
      plant: plantName,
      interval: timePeriod.interval,
      device: device,
      timezoneName: timezone.name,
      metrics: ["duration_sum"],
      bins: ["states", "device"]
    })
  }, function (_ref) {
    var data = _ref.data,
      fetching = _ref.fetching;
    if (fetching) {
      return /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
    }
    if (data.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(ErrorText, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Widgets.NoData.Warning",
        defaultMessage: "No Data Available"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_UtilizationSummaryDataFormatter.UtilizationSummaryDataFormatter, {
      selectedStates: selectedStates,
      data: data,
      devices: device,
      tooltipSort: tooltipSort
    }, function (_ref2) {
      var series = _ref2.series;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: 4
        }
      }, /*#__PURE__*/_react["default"].createElement(_ScrollableChart.ScrollableChart, _extends({}, props, {
        width: width,
        height: height,
        minorBarPerMajorBar: 1,
        minorBarSize: 50,
        series: series,
        xAxisLabel: "Summary",
        tickXFormat: tickXFormatter,
        builtInTooltip: false
      })));
    });
  }));
};